import type { ReactElement } from "react";
import { Skeleton } from "@/components/atoms";
import "./CastingList.scss";
import "./CastingFiltersSkeleton.scss";

const RADIO_PILL_WIDTHS = [120, 140, 150, 170] as const;

/** Loading placeholder matching CastingList filter toolbar layout. */
export function CastingFiltersSkeleton(): ReactElement {
  return (
    <>
      <div
        className="castings__filter-radio casting-filters-skeleton"
        aria-hidden="true"
      >
        <div className="casting-filters-skeleton__radio-group">
          {RADIO_PILL_WIDTHS.map((width, index) => (
            <Skeleton
              key={`casting-filter-radio-${index}`}
              borderRadius="base"
              borderWeight="base"
              width={width}
              className="casting-filters-skeleton__radio-pill"
            />
          ))}
        </div>
        <Skeleton
          borderRadius="base"
          borderWeight="base"
          width={180}
          className="casting-filters-skeleton__add-btn"
        />
      </div>

      <div
        className="castings__filter-select casting-filters-skeleton"
        aria-hidden="true"
      >
        <div className="castings__filter-gender-label">
          <Skeleton
            variant="text"
            className="casting-filters-skeleton__label"
          />
        </div>
        <Skeleton
          borderRadius="sm"
          borderWeight="base"
          className="castings__filter-gender-btn casting-filters-skeleton__select"
        />
        <Skeleton
          borderRadius="base"
          borderWeight="base"
          className="castings__add-casting-btn casting-filters-skeleton__add-btn casting-filters-skeleton__add-btn--mobile"
        />
      </div>
    </>
  );
}
